import {
  OrderDataEntryForm,
  PaginatedOrderDetails,
  SubmitOrderResponse,
} from "types/model.types";
import { authApi } from "./";

const apiOrderPrefix = "order";

// #region Admin Order APIs

export const getAdminOrders = async (
  pageNumber = 1,
  pageSize = 30,
): Promise<void | PaginatedOrderDetails> => {
  const { data } = await authApi.post<PaginatedOrderDetails>(
    `${apiOrderPrefix}/getAdminOrders`,
    {
      pageNumber,
      pageSize,
    },
  );
  return data ?? [];
};
export const getAdminOrderById = async (
  id: number,
): Promise<void | OrderDataEntryForm> => {
  return await authApi
    .post<OrderDataEntryForm>(`${apiOrderPrefix}/getAdminOrderById`, { id })
    .then((resp) => resp.data);
};
export const submitAdminOrder = async (
  payload: any,
): Promise<void | SubmitOrderResponse> => {
  const { data } = await authApi.post<SubmitOrderResponse>(
    `${apiOrderPrefix}/submitAdminOrder`,
    payload,
  );
  return data;
};
export const changeOrderDate = async (
  orderId: number,
  orderDate: string,
): Promise<void> => {
  const { data } = await authApi.post(`${apiOrderPrefix}/changeOrderDate`, {
    orderId,
    orderDate,
  });
  return data;
};
export const deleteAdminOrder = async (id: number): Promise<void | any> => {
  const { data } = await authApi.post<any>(
    `${apiOrderPrefix}/deleteAdminOrder`,
    {
      id,
    },
  );
  return data;
};
export const deleteAdminOrderDetails = async (
  orderId: number,
  orderDetailsId: number,
): Promise<void | any> => {
  const { data } = await authApi.post<any>(
    `${apiOrderPrefix}/deleteAdminOrderDetails`,
    {
      orderId,
      orderDetailsId,
    },
  );
  return data;
};
export const updateAdminOrderPrintState = async (
  orderId: number,
  isPickingListPrinted: boolean,
  isPackingSlipPrinted: boolean,
  isInvoicePrinted: boolean,
  invoiceId: number,
): Promise<void | any> => {
  const { data } = await authApi.post<any>(
    `${apiOrderPrefix}/updateAdminOrderPrintState`,
    {
      orderId,
      isPickingListPrinted,
      isPackingSlipPrinted,
      isInvoicePrinted,
      invoiceId,
    },
  );
  return data;
};
// #endregion

// #region Public Order APIs

export const getOrders = async () => {
  const response = await authApi.post(
    `${apiOrderPrefix}/getOrders`,
    undefined,
    {},
  );
  return response ?? [];
};
export const getOrdersByDebtor = async (debtorCode: number | undefined) => {
  const response = await authApi.post(`${apiOrderPrefix}/getOrdersByCustomer`, {
    debtorCode,
  });
  return response ?? [];
};
export const getOrderDetails = async (orderId: number) => {
  const response = await authApi.post(`${apiOrderPrefix}/getOrderDetails`, {
    orderId,
  });
  return response ?? [];
};
export const getBackOrders = async () => {
  const response = await authApi.post(
    `${apiOrderPrefix}/getBackOrders`,
    undefined,
    {},
  );
  return response ?? [];
};

// #endregion
